import { render } from "./CategoriaComponent.vue?vue&type=template&id=2b05fd1b"
import script from "./CategoriaComponent.vue?vue&type=script&lang=js"
export * from "./CategoriaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__